export const initialValues: ISignUpCommand = {
  fullName: '',
  email: '',
  city: '',
  province: '',
  account_type: '',
  country: 'ایران',
};
